<ng-container *ngFor="let warning of warnings">
  <div class="alert alert-warning mt-3">
    <div [innerHTML]="warning.infoText">
    </div>
  </div>
</ng-container>
